import script from "./photoView.vue?vue&type=script&setup=true&lang=js"
export * from "./photoView.vue?vue&type=script&setup=true&lang=js"

import "./photoView.vue?vue&type=style&index=0&id=04d32f10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d32f10"]])

export default __exports__